export const getColumnValues = (data, col) => {
  let value = [];

  data.forEach((dat, index) => {
    if (
      Object.keys(dat).length > 0 &&
      dat[col] !== undefined &&
      index !== 0 &&
      Number(dat[col])
    ) {
      // console.log(value);
      value.push(Number(dat[col]));
    }
  });

  return value;
};
